/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */

import { css as cssUnbounded } from '@compiled/react';

import { cssMap, jsx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import DefaultIcon from './assets/default-fallback-icon.svg';
import TwgIcon from './assets/TWG.svg';
import { ShimmerIcon } from './ShimmerIcon';

const toolIconStyle = cssUnbounded({
	width: '16px',
	height: '16px',
	display: 'block',
	objectFit: 'contain',
});

const iconMaskStyle = cssUnbounded({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: token('elevation.surface'),
	width: '28px',
	height: '32px',
	position: 'relative',
	zIndex: 1,
});

const styles = cssMap({
	stepIconContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		flexShrink: 0,
		overflow: 'visible',
	},
});

type TraceStepIconProps = {
	isInProgress: boolean;
	toolIcon: string | undefined;
	isTwg: boolean;
	activeLoadingIcon: string | undefined;
	iconError: boolean;
	onIconError: () => void;
};

export const TraceStepIcon = ({
	isInProgress,
	toolIcon,
	isTwg,
	activeLoadingIcon,
	iconError,
	onIconError,
}: TraceStepIconProps): JSX.Element => {
	const renderIcon = (iconSrc: string | undefined) => {
		if (isTwg) {
			return <Image src={TwgIcon} alt="" width={16} height={16} />;
		}
		if (iconSrc && !iconError) {
			return (
				<img
					src={iconSrc}
					alt=""
					width={16}
					height={16}
					css={toolIconStyle}
					onError={onIconError}
				/>
			);
		}
		return <Image src={DefaultIcon} alt="" width={16} height={16} />;
	};

	return (
		<Box xcss={styles.stepIconContainer}>
			{/* Icon with background mask that covers the parent's vertical line */}
			<div css={iconMaskStyle}>
				{isInProgress ? (
					<ShimmerIcon>{renderIcon(activeLoadingIcon)}</ShimmerIcon>
				) : (
					renderIcon(toolIcon)
				)}
			</div>
		</Box>
	);
};
